import React from 'react';
import ReactIframeResizer from 'react-iframe-resizer-super';

class Lagerkonfigurator extends React.Component {
  render() {
    return (
      <ReactIframeResizer
        iframeResizerUrl={false}
        iframeResizerOptions={{
          checkOrigin: false,
        }}
        src="https://www.power-pellets.de/energieverbrauchsrechner/lagerraumkonzeption/rect.html?utm_source=tool&utm_medium=Pelletlagerkonfigurator&utm_campaign=integration&page=1"
      />
    );
  }
}

export default Lagerkonfigurator;
